module.exports = __webpack_public_path__ + "img/account_money_send.b01af81d.svg";